import { render, staticRenderFns } from "./AccountSettings.html?vue&type=template&id=fdf280cc&scoped=true&"
import script from "./AccountSettings.ts?vue&type=script&lang=ts&"
export * from "./AccountSettings.ts?vue&type=script&lang=ts&"
import style0 from "@/scss/components/account/_settings.scss?vue&type=style&index=0&id=fdf280cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdf280cc",
  null
  
)

export default component.exports